import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import nftContractAbi from "../Contracts/nft.json";
import {
  useContractReads,
  useContractWrite,
  usePrepareContractWrite,
} from "wagmi";
import { GenesisStakingContext } from "../Pages/GenesisStaking";

const NftList = ({ nftArray }) => {
  const { dailyRewards, buttonText, setTransactionHash, transactionConfirmHook } = useContext(
    GenesisStakingContext
  );
  const [nftsFinal, setNftsFinal] = useState([]);
  const [selectedNft, setSelectedNft] = useState(0);
  const [btnIsLoading, setBtnIsLoading] = useState(false);

  let args = [];
  for (let i = 0; i < nftArray.length; i++) {
    const preparedData = {
      address: process.env.REACT_APP_NFT_CONTRACT,
      abi: nftContractAbi,
      functionName: "tokenURI",
      args: [nftArray[i].tokenId],
    };
    args.push(preparedData);
  }

  const { data: data, isFetched: isFetched } = useContractReads({
    contracts: args,
  });

  useEffect(() => {
    const fetchData = async (data, nftArray, setNftsFinal) => {
      const promises = data.map(async (item, index) => {
        if (item.status !== "failure") {
          const response = await fetch(item.result);
          const responseJson = await response.json();
          return {
            tokenId: nftArray[index].tokenId,
            imageUrl: responseJson.image,
          };
        }
      });

      const nftDataArray = await Promise.all(promises);
      if (nftDataArray[0] !== undefined) {
        setNftsFinal(nftDataArray);
      }
    };

    if (isFetched) {
      fetchData(data, nftArray, setNftsFinal);
    }
  }, [data, isFetched, nftArray]);

  // const { config: config, refetch: refetch } = usePrepareContractWrite({
  //   address: process.env.REACT_APP_NFT_CONTRACT,
  //   abi: nftContractAbi,
  //   functionName: buttonText.toLowerCase()
  // });

  const funcStake = useContractWrite({
    address: process.env.REACT_APP_NFT_CONTRACT,
    abi: nftContractAbi,
    functionName: buttonText.toLowerCase(),
    onSuccess(data) {
      setTransactionHash(data.hash);
      toast.success(`Transaction Hash: ${data.hash}`, {
        duration: 15000,
      });
    },
    onError(error) {
      toast.error(`Error: ${error.message}`, { duration: 15000 });
    },
  });

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setBtnIsLoading(true);
    // await refetch();
    console.log("selectedNft", selectedNft);
    funcStake.write({args: [selectedNft] });
  };

  return (
    <div>
      <div className="grid grid-cols-1 gap-8 mt-8 md:mt-16 md:grid-cols-5">
        {nftsFinal && nftsFinal.length > 0
          ? nftsFinal.map((item, index) => {
              return (
                <>
                  <form onSubmit={handleFormSubmit}>
                    <div className="flex flex-col justify-center items-center h-full">
                      <div className="!z-5 relative flex flex-col rounded-[20px] max-w-[300px] bg-white bg-clip-border shadow-3xl shadow-shadow-500 w-full !p-4 3xl:p-![18px] undefined">
                        <div className="h-full w-full">
                          <div className="relative w-full">
                            <img
                              src={item.imageUrl}
                              className="mb-3 h-full w-full rounded-xl 3xl:h-full 3xl:w-full"
                              alt=""
                            />
                            <button className="absolute top-3 right-3 flex items-center justify-center rounded-full bg-white p-2 text-brand-500 hover:cursor-pointer">
                              <div className="flex h-full w-full items-center justify-center rounded-full text-xl hover:bg-gray-50">
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  stroke-width="0"
                                  viewBox="0 0 512 512"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="32"
                                    d="M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"
                                  ></path>
                                </svg>
                              </div>
                            </button>
                          </div>
                          <div className="text-black">BB # {item.tokenId}</div>
                          <div className="flex items-center justify-between md:items-center lg:justify-between ">
                            <div className="flex">
                              <p className="!mb-0 text-sm font-bold text-brand-500 text-black">
                                Rewards: {dailyRewards} BIBK/Day
                              </p>
                            </div>
                            {btnIsLoading &&
                            selectedNft === item.tokenId ? (
                              <button
                                disabled={true}
                                type="button"
                                className="py-2.5 px-5 mr-2 text-sm font-medium text-gray-900 bg-white rounded border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 inline-flex items-center"
                              >
                                <svg
                                  aria-hidden="true"
                                  role="status"
                                  className="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600"
                                  viewBox="0 0 100 101"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                  ></path>
                                  <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="#1C64F2"
                                  ></path>
                                </svg>
                                Loading...
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  setSelectedNft(item.tokenId);
                                }}
                                className="linear rounded-[20px] bg-brand-900 px-4 py-2 text-base font-medium bg-black transition duration-200 hover:bg-brand-800 active:bg-brand-700"
                              >
                                {buttonText}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </>
              );
            })
          : null}
      </div>
    </div>
  );
};

export default NftList;
// export default NftList;
